const columns = [
  {
    title: "Ticket No",
    dataIndex: "ticketNo",
    // sorter: true
  },
  {
    title: "Query Type",
    dataIndex: "queryType",
    
  },
  {
    title: "Title",
    dataIndex: "title",
    
  },
  {
    title: "Contact Name",
    dataIndex: "name",
  },
  // {
  //   title: "User Type",
  //   dataIndex: "userType",
  //   // sorter: true
  // },
  {
    title: "Priority",
    dataIndex: "priority",
  },
  {
    title: "Open Date",
    dataIndex: "openDate",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Actions",
    dataIndex: "actions",
  },
];

export default columns;
